import React, { useMemo } from 'react';
import { SxProps, Typography } from '@mui/material';
import { BreadcrumbsStyled, DivLinkStyled, LinkStyled, RootStyled } from './PageHeaderWithBreadcrumbs.styles';
import { IBreadcrumbsItem } from './PageHeaderWithBreadcrumbs.types';

interface PageHeaderWithBreadcrumbsProps {
  breadcrumbs?: IBreadcrumbsItem[];
  pageTitle: string;
  sx?: SxProps;
}

export const PageHeaderWithBreadcrumbs: React.FC<PageHeaderWithBreadcrumbsProps> = ({ pageTitle, breadcrumbs, sx }) => {
  /**
   * If one item in breadcrumbs, separator should be shown.
   */
  const updatedBreadCrumbs = useMemo(() => {
    if (!breadcrumbs) {
      return;
    }
    if (breadcrumbs.length > 1) {
      return breadcrumbs;
    }
    return [...breadcrumbs, { name: '' }];
  }, [breadcrumbs]);

  return (
    <RootStyled sx={{ justifyContent: updatedBreadCrumbs ? undefined : 'center', ...sx }}>
      <BreadcrumbsStyled separator=">">
        {updatedBreadCrumbs?.map((item, i) => {
          if (item?.to) {
            return (
              <Typography variant="caption" key={item.name}>
                <LinkStyled isLastItem={i === updatedBreadCrumbs.length - 1} to={item.to} {...item.extraAttributes}>
                  {item.name}
                </LinkStyled>
              </Typography>
            );
          }
          if (item.onClick) {
            return (
              <Typography variant="caption" key={item.name} onClick={item.onClick}>
                <DivLinkStyled {...item.extraAttributes}>{item.name}</DivLinkStyled>
              </Typography>
            );
          }
          return (
            <Typography variant="caption" key={item.name}>
              {item.name}
            </Typography>
          );
        })}
      </BreadcrumbsStyled>

      <Typography variant="h5">{pageTitle}</Typography>
    </RootStyled>
  );
};

export default PageHeaderWithBreadcrumbs;
